import { BaseController } from '@maia/feature-utils';
import {
  CancellationQuestionsDto,
  CancellationService,
  CartService,
  GetCartDto,
  MutationService,
  ProconditionQuestionDto,
  ProductQuestionDto,
  ProductsDto,
  UpsellProductsDto,
} from '@maia/shared';

export class CartController extends BaseController {
  constructor(
    private cartService: CartService,
    private mutationService: MutationService,
    private cancellationService: CancellationService,
  ) {
    super();
  }

  async getUpsellproducts(
    params: Parameters<typeof this.cartService.getUpsellproducts>[number],
  ) {
    const response = await this.cartService.getUpsellproducts(params);
    return response.map((res) => new UpsellProductsDto(res));
  }

  async createCart(
    params: Parameters<typeof this.cartService.createCart>[number],
  ) {
    return await this.cartService.createCart(params);
  }

  async getCart(params: Parameters<typeof this.cartService.getCart>[number]) {
    const response = await this.cartService.getCart(params);
    return new GetCartDto(response);
  }

  async getProducts(
    params: Parameters<typeof this.cartService.getProducts>[number],
  ) {
    const response = await this.cartService.getProducts(params);
    return response.map((res) => new ProductsDto(res));
  }

  async getQuestions(
    params: Parameters<typeof this.cartService.getQuestions>[number],
  ) {
    const response = await this.cartService.getQuestions(params);
    return response.map((question) => new ProductQuestionDto(question));
  }

  async putQuestions(
    params: Parameters<typeof this.cartService.putQuestions>[number],
  ) {
    return await this.cartService.putQuestions(params);
  }

  async getCompositions(
    params: Parameters<typeof this.cartService.getCompositions>[number],
  ) {
    return await this.cartService.getCompositions(params);
  }

  async putCompositions(
    params: Parameters<typeof this.cartService.putCompositions>[number],
  ) {
    return await this.cartService.putCompositions(params);
  }

  async getCompositionQuestions(
    params: Parameters<typeof this.cartService.getCompositionQuestions>[number],
  ) {
    const response = await this.cartService.getCompositionQuestions(params);
    return new ProductsDto(response);
  }

  async submitCart(body: Parameters<typeof this.cartService.submitCart>[0]) {
    return await this.cartService.submitCart(body);
  }

  async createMutation(
    params: Parameters<typeof this.mutationService.createMutation>[0],
  ) {
    return await this.mutationService.createMutation(params);
  }

  async getMutationCart(
    params: Parameters<typeof this.mutationService.getMutationCart>[0],
  ) {
    const response = await this.mutationService.getMutationCart(params);
    return response;
  }

  async putPreconditionMutationQuestions(
    params: Parameters<typeof this.mutationService.putPreconditionQuestions>[0],
  ) {
    return await this.mutationService.putPreconditionQuestions(params);
  }

  async putCompositionsMutation(
    body: Parameters<typeof this.mutationService.putCompositions>[0],
  ) {
    return await this.mutationService.putCompositions(body);
  }

  async putProductMutationQuestion(
    body: Parameters<typeof this.mutationService.putProductQuestion>[0],
  ) {
    return await this.mutationService.putProductQuestion(body);
  }

  async submitMutation(
    params: Parameters<typeof this.mutationService.submitMutation>[number],
  ) {
    return await this.mutationService.submitMutation(params);
  }

  async getPreconditionQuestions(
    params: Parameters<typeof this.mutationService.getPreconditionQuestions>[0],
  ) {
    const response =
      await this.mutationService.getPreconditionQuestions(params);
    return response.map((question) => new ProconditionQuestionDto(question));
  }

  async getMutationCompositions(
    params: Parameters<typeof this.mutationService.getCompositions>[0],
  ) {
    return await this.mutationService.getCompositions(params);
  }

  async getMutationProducts(
    params: Parameters<typeof this.mutationService.getProducts>[0],
  ) {
    const response = await this.mutationService.getProducts(params);
    return response.map((res) => new ProductsDto(res));
  }

  async createCancellation(
    params: Parameters<typeof this.cancellationService.createCancellation>[0],
  ) {
    return await this.cancellationService.createCancellation(params);
  }

  async getCancellationQuestions(
    params: Parameters<
      typeof this.cancellationService.getCancellationQuestions
    >[0],
  ) {
    const response =
      await this.cancellationService.getCancellationQuestions(params);
    return new CancellationQuestionsDto(response);
  }

  async putCancellationQuestions(
    params: Parameters<
      typeof this.cancellationService.putCancellationQuestions
    >[0],
  ) {
    return await this.cancellationService.putCancellationQuestions(params);
  }

  async submitCancellation(
    params: Parameters<typeof this.cancellationService.submitCancellation>[0],
  ) {
    return await this.cancellationService.submitCancellation(params);
  }
}
